/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeleteFacilityRegion200ResponseData } from './DeleteFacilityRegion200ResponseData';
import {
    DeleteFacilityRegion200ResponseDataFromJSON,
    DeleteFacilityRegion200ResponseDataFromJSONTyped,
    DeleteFacilityRegion200ResponseDataToJSON,
    DeleteFacilityRegion200ResponseDataToJSONTyped,
} from './DeleteFacilityRegion200ResponseData';

/**
 * 
 * @export
 * @interface DeleteFacilityRegion200Response
 */
export interface DeleteFacilityRegion200Response {
    /**
     * 
     */
    data?: DeleteFacilityRegion200ResponseData;
}

/**
 * Check if a given object implements the DeleteFacilityRegion200Response interface.
 */
export function instanceOfDeleteFacilityRegion200Response(value: object): value is DeleteFacilityRegion200Response {
    return true;
}

export function DeleteFacilityRegion200ResponseFromJSON(json: any): DeleteFacilityRegion200Response {
    return DeleteFacilityRegion200ResponseFromJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityRegion200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DeleteFacilityRegion200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteFacilityRegion200ResponseToJSON(json: any): DeleteFacilityRegion200Response {
    return DeleteFacilityRegion200ResponseToJSONTyped(json, false);
}

export function DeleteFacilityRegion200ResponseToJSONTyped(value?: DeleteFacilityRegion200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DeleteFacilityRegion200ResponseDataToJSON(value['data']),
    };
}

